import s from './Label.module.scss';
import styles from '@/app/components/ui/inputs/Input/Input.module.scss';

const Label = ({
  htmlFor,
  children,
  hasError = false,
  required = false,
  number = 1,
}) => {
  return (
    <label htmlFor={htmlFor} className={`${s.label}`}>
      {number && <span className={s.number}>{number}</span>}
      <span className={`${hasError ? 'textRed' : ''}`}>{children}</span>
      {/*{required && <span className={styles.required}>*</span>}*/}
    </label>
  );
};

export default Label;
